/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdvancedSubmissionSearchDto { 
    requestedType?: AdvancedSubmissionSearchDtoRequestedTypeEnum;
    organizationsIds?: Array<string>;
    productName?: string;
    productNumber?: string;
    parentDetails?: string;
    showChildren?: boolean;
    submissionNumber?: string;
    scipNumber?: string;
    echaDossierType?: AdvancedSubmissionSearchDtoEchaDossierTypeEnum;
    submissionDateFrom?: string;
    submissionDateTo?: string;
    submissionStatuses?: Array<AdvancedSubmissionSearchDtoSubmissionStatusesEnum>;
    organizationGroupIds?: Array<string>;
}
export enum AdvancedSubmissionSearchDtoRequestedTypeEnum {
    All = 'ALL',
    Standard = 'STANDARD',
    PartsOnly = 'PARTS_ONLY',
    Referencing = 'REFERENCING'
};
export enum AdvancedSubmissionSearchDtoEchaDossierTypeEnum {
    All = 'ALL',
    Full = 'FULL',
    Simplified = 'SIMPLIFIED'
};
export enum AdvancedSubmissionSearchDtoSubmissionStatusesEnum {
    DossierRequested = 'DOSSIER_REQUESTED',
    DossierFileInPreparation = 'DOSSIER_FILE_IN_PREPARATION',
    DossierFailedToCreate = 'DOSSIER_FAILED_TO_CREATE',
    DossierFileCreated = 'DOSSIER_FILE_CREATED',
    DossierSentToEcha = 'DOSSIER_SENT_TO_ECHA',
    Pending = 'PENDING',
    Submitted = 'SUBMITTED',
    AllPartsCompleted = 'ALL_PARTS_COMPLETED',
    OneOrMoreFailed = 'ONE_OR_MORE_FAILED',
    ValidationSucceeded = 'VALIDATION_SUCCEEDED',
    Failed = 'FAILED',
    ValidationFailed = 'VALIDATION_FAILED',
    DossierTooLarge = 'DOSSIER_TOO_LARGE'
};



